export default "__VITE_ASSET__Duwyyh2Y__"